var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[(_vm.the_form)?_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('q-form-entries-data-table',{attrs:{"slug":_vm.$route.params.form_slug,"title":_vm.the_form.FormTitle +' Data',"custom-form-url":_vm.customFormUrl,"allow-ao":_vm.allowAo}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }